import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=8e982528&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=8e982528&prod&lang=less"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=8e982528&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e982528",
  null
  
)

export default component.exports